import * as Immutable from "immutable";
import useHistory from "routing/useHistory";
import Routes from "routing/Routes";
import View from "views/logic/views/View";
import useCurrentUser from "hooks/useCurrentUser";
import useViewsSelector from "views/stores/useViewsSelector";
import useSaveViewFormControls from "views/hooks/useSaveViewFormControls";
import createSearch from "views/logic/slices/createSearch";
import { executePluggableSearchDuplicationHandler } from "views/logic/views/pluggableSaveViewFormHandler";
import { selectCurrentQuery, selectCurrentQueryResults } from "views/logic/slices/viewSelectors";
import { createView } from "views/api/views";
const saveSearchAs = (view, effectiveTimerange, currentQuery, currentUser, push, saveViewControl) => async (newTitle) => {
  const viewWithPluginData = await executePluggableSearchDuplicationHandler(
    view,
    currentUser.permissions,
    saveViewControl
  );
  const newQuery = currentQuery.toBuilder().newId().timerange(effectiveTimerange).build();
  const newSearch = view.search.toBuilder().newId().queries([newQuery]).build();
  const savedSearch = await createSearch(newSearch);
  const newView = viewWithPluginData.toBuilder().newId().title(newTitle).type(View.Type.Search).search(savedSearch).state(Immutable.Map({ [newQuery.id]: view.state.get(currentQuery.id) })).build();
  const savedView = await createView(newView);
  push(Routes.VIEWS.VIEWID(savedView.id));
  return savedView;
};
function useSearchSrvc(view) {
  const { push } = useHistory();
  const currentQuery = useViewsSelector(selectCurrentQuery);
  const results = useViewsSelector(selectCurrentQueryResults);
  const currentUser = useCurrentUser();
  const pluggableSaveViewControls = useSaveViewFormControls();
  const isSearchRelative = currentQuery.toJSON().timerange.type === "relative";
  const saveAsAbsoluteSearch = saveSearchAs(
    view,
    results == null ? void 0 : results.effectiveTimerange,
    currentQuery,
    currentUser,
    push,
    pluggableSaveViewControls
  );
  return { isSearchRelative, saveAsAbsoluteSearch };
}
export default useSearchSrvc;
